import Picture from "@/Components/Picture";

const ParagraphBlock = ({file, caption}) => {
    return <Picture src={file?.url} alt={caption} className={`re-picture`} imageClassName={`re-image`} />;
};

export default ParagraphBlock;
